<template>
	<div data-tour-scope="messages">
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center>
					<v-card width="100%" outlined elevation-0>
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title> {{ title }}</v-toolbar-title>
							<v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()"><v-icon left>mdi-school-outline</v-icon>Tutorial guidato</v-btn>

							<v-spacer />
							<v-toolbar-items shift>
								<!-- una sola azione possibile: il piu' porta dritto alla pagina, senza menu -->
								<v-btn v-if="!readOnly" elevation="0" text title="Scrivi una comunicazione" data-tour="add" @click="createItem">
									<v-icon>mdi-plus</v-icon>
								</v-btn>
							</v-toolbar-items>
						</v-toolbar>


						<!-- filtri in pagina: finiscono nell'URL, un refresh o il ritorno da una scheda li ritrova -->
						<v-col cols="12">
							<v-row data-tour="filters">
								<v-col v-if="receiversList.length > 0" cols="12" md="3">
									<v-autocomplete v-model="settings.filters.receiver" :items="receiversList" item-text="name" item-value="id" label="Destinatario" outlined dense clearable hide-details />
								</v-col>
								<v-col cols="12" md="3">
									<v-select v-model="settings.filters.read" :items="readOptions" label="Letto" outlined dense clearable hide-details />
								</v-col>
							</v-row>
						</v-col>

						<v-data-table
							:options.sync="settings.options"
							:headers="headers"
							:items="getItems"
							:server-items-length="total"
							must-sort
							class="elevation-0"
							:footer-props="{ 'items-per-page-options': listSize }"
							item-key="_id"
							data-tour="table"
							:hide-default-header="mobileCards"
							:class="{ 'table-cards': mobileCards }"
						>
							<template #body="{ items }">
								<!-- telefono: ogni riga diventa una card chiave/valore -->
								<tbody v-if="mobileCards" class="message-cards">
									<tr v-for="item in items" :key="item._id">
										<td :colspan="headers.length" class="px-3 py-1">
											<key-value-card :title="item.title || 'Senza titolo'" :fields="campiCard(item)">
												<template #actions>
													<v-menu top eager>
														<template #activator="{ on, attrs }">
															<v-btn icon small v-bind="attrs" color="primary" v-on="on" data-tour="row-menu">
																<v-icon>mdi-dots-vertical</v-icon>
															</v-btn>
														</template>
														<v-list>
															<template v-if="readOnly">
																<v-list-item link data-tour="row-show" @click="showItem(item)">
																	<v-list-item-title class="size9"> Visualizza </v-list-item-title>
																</v-list-item>
															</template>
															<template v-else>
																<v-list-item link data-tour="row-edit" @click="editItem(item)">
																	<v-list-item-title class="size9"> Modifica </v-list-item-title>
																</v-list-item>
																<v-list-item link data-tour="row-delete" @click="deleteItem(item)">
																	<v-list-item-title class="size9"> Elimina </v-list-item-title>
																</v-list-item>
															</template>
														</v-list>
													</v-menu>
												</template>
												<div data-tour="read">
													<v-chip v-if="item.read" label small color="green" text-color="white">
														<strong>Letto alle {{ new Date(item.read_at).toLocaleString() }}</strong>
													</v-chip>
													<v-chip v-else label small color="red" text-color="white">
														<strong>Non letto</strong>
													</v-chip>
												</div>
											</key-value-card>
										</td>
									</tr>
									<tr v-if="!items.length">
										<td :colspan="headers.length" class="text-center grey--text py-6">Nessuna comunicazione</td>
									</tr>
								</tbody>
								<tbody v-else>
									<tr v-for="item in items" :key="`${item._id}`">
										<td class="pl-0 pr-0 ml-0 mr-0" style="width: 5px">
											<v-menu top eager>
												<template #activator="{ on, attrs }">
													<v-btn icon dark v-bind="attrs" color="primary" dense v-on="on" data-tour="row-menu">
														<v-icon dark> mdi-dots-vertical </v-icon>
													</v-btn>
												</template>
												<v-list>
													<template v-if="readOnly">
														<v-list-item link data-tour="row-show" @click="showItem(item)">
															<v-list-item-title class="size9"> Visualizza </v-list-item-title>
														</v-list-item>
													</template>
													<template v-else>
														<v-list-item link data-tour="row-edit" @click="editItem(item)">
															<v-list-item-title class="size9"> Modifica </v-list-item-title>
														</v-list-item>
														<v-list-item link data-tour="row-delete" @click="deleteItem(item)">
															<v-list-item-title class="size9"> Elimina </v-list-item-title>
														</v-list-item>
													</template>
												</v-list>
											</v-menu>
										</td>
										<td class="text-left">
											{{ new Date(item.created_at).toLocaleString() }}
										</td>
										<td class="text-left">{{ item.title }}</td>
										<td class="text-left">
											{{ item.sender && item.sender.name }}
										</td>
										<td class="text-left">
											{{ item.receiver && item.receiver.name }}
										</td>
										<td data-tour="read" class="text-left">
											<v-chip v-if="item.read" label small color="green" text-color="white">
												<strong>Letto alle {{ new Date(item.read_at).toLocaleString() }}</strong>
											</v-chip>
											<v-chip v-else label small color="red" text-color="white">
												<strong> Non letto</strong>
											</v-chip>
										</td>
									</tr>
									<tr v-if="!items.length">
										<td :colspan="headers.length" class="text-center grey--text py-6">Nessuna comunicazione</td>
									</tr>
								</tbody>
							</template>
						</v-data-table>
					</v-card>
					<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :vertical="snackbar.mode === 'vertical'">
						{{ snackbar.text }}
						<v-btn dark text @click="snackbar.snackbar = false"> Chiudi </v-btn>
					</v-snackbar>
				</v-layout>
			</v-container>
		</v-main>

		<v-dialog v-model="dialogconfirm" max-width="340">
			<v-card>
				<v-card-title class="headline"> Sei sicuro? </v-card-title>
				<v-card-text class="text-left">
					La comunicazione <b>{{ form && form.title }}</b> per {{ form && form.receiver && form.receiver.name }} verrà eliminata e non potrà più essere ripristinata.
				</v-card-text>

				<v-card-actions>
					<v-spacer />

					<v-btn color="primary" text @click="dialogconfirm = false"> Annulla </v-btn>

					<v-btn color="primary" text @click="confirmDelete"> Elimina </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<!-- Ultimo elemento: il nodo viene spostato in `[data-app]` al montaggio. -->
		<TourOverlay :tour="tour"></TourOverlay>
	</div>
</template>

<script>
import _ from 'lodash';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import KeyValueCard from '@/components/core/KeyValueCard.vue';
import { useTour } from '@/components/core/tour/useTour';
import { listRouteState } from '@/components/core/list/listRouteState';
import { createMessagesTourSteps } from './messages-tour';

const LIST_SIZE = [15, 25, 50, 100];

export default {
	name: 'MessagesIndex',
	// pagina, righe, ordinamento e filtri stanno nell'URL: refresh e ritorno dalle schede ripartono da li'
	mixins: [listRouteState({ filters: { receiver: 'string', read: 'string' }, perPageOptions: LIST_SIZE })],
	setup() {
		return { tour: useTour(createMessagesTourSteps()) };
	},
	components: {
		KeyValueCard,
		TourOverlay,
	},
	data() {
		return {
			title: this.$vuetify.lang.t('$vuetify.front.messages.list'),
			dialogconfirm: false,
			form: null,

			readOnly: this.$store.getters['profile/getRole'] === 2,

			headers: [
				// colonna del menu a tre puntini: non si ordina
				{ text: '', value: '', sortable: false },
				{ text: 'Data Invio', value: 'created_at' },
				{ text: 'Titolo', value: 'title' },
				{ text: 'Mittente', value: 'sender.name' },
				{ text: 'Destinatario', value: 'receiver.name' },
				{ text: 'Letto', value: 'read' },
			],

			listSize: LIST_SIZE,
			total: 0,

			receiversList: [],
			readOptions: [
				{ text: 'Lette', value: 'yes' },
				{ text: 'Non lette', value: 'no' },
			],
			settings: this.listSettingsFromRoute({
				search: '',
				filters: {
					receiver: '',
					read: '',
				},
				options: {
					sortBy: ['created_at'],
					sortDesc: [true],
					page: 1,
					itemsPerPage: 15,
				},
			}),

			snackbar: {
				snackbar: false,
				color: '',
				mode: '',
				timeout: 6000,
				text: '',
			},
		};
	},
	computed: {
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		...mapGetters({
			getItems: 'messages/getItems',
			getUsers: 'users/getUsers',
		}),
	},
	async created() {
		this.setExistFilter(true);
		this.listLoad();
		if (!this.readOnly) {
			await this.fetchUsers();
			this.receiversList = _.orderBy(
				(this.getUsers || []).map(u => ({ name: u.name, id: u._id })),
				['name'],
				['asc'],
			);
		}
	},
	beforeDestroy() {
		// Se si lascia la pagina a giro aperto, vanno staccati i listener del tutorial.
		this.tour.stop();
		this.destroyData();
	},
	methods: {
		// stessi dati delle colonne Data Invio/Mittente/Destinatario della tabella desktop
		campiCard(item) {
			return [
				{ label: 'Data invio', value: item.created_at ? new Date(item.created_at).toLocaleString() : '' },
				{ label: 'Mittente', value: item.sender && item.sender.name },
				{ label: 'Destinatario', value: item.receiver && item.receiver.name },
			];
		},
		...mapMutations({
			setPreload: 'settings/setPreload',
			setExistFilter: 'settings/setExistFilter',
		}),
		...mapActions({
			fetchItems: 'messages/asyncFetchData',
			destroyData: 'messages/destroyData',
			deleteItems: 'messages/deleteItems',
			fetchUsers: 'users/asyncFetchUsers',
		}),
		// inserimento, modifica e dettaglio sono pagine: la lista resta nel suo URL e ci si torna uguale
		createItem() {
			this.$router.push('/messages/new');
		},
		editItem(item) {
			this.$router.push(`/messages/${item._id}`);
		},
		showItem(item) {
			this.$router.push(`/messages/${item._id}`);
		},
		// ritorna la promessa: confirmDelete aspetta il ricaricamento prima del messaggio
		getDataFromApi() {
			this.setPreload(true);
			return this.fetchItems(this.settings)
				.then(result => {
					this.total = (result && result.total) || 0;
				})
				.catch(err => {
					console.log(err);
				})
				.finally(() => {
					this.setPreload(false);
				});
		},
		deleteItem(item) {
			this.form = item;
			this.dialogconfirm = true;
		},
		confirmDelete() {
			this.dialogconfirm = false;
			// solo la comunicazione scelta dai tre puntini
			if (!this.form || !this.form._id) return;
			this.setPreload(true);
			this.deleteItems([{ _id: this.form._id }])
				.then(() => this.getDataFromApi())
				.then(() => {
					this.snackbar.color = 'success';
					this.snackbar.text = 'Comunicazione eliminata';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
				})
				.catch(error => {
					console.log(error);
				})
				.finally(() => {
					this.setPreload(false);
				});
		},
	},
};
</script>

<style scoped>
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.message-cards,
.message-cards tr {
	display: block;
	width: 100%;
}
.message-cards tr,
.message-cards tr:hover {
	background: transparent !important;
}
.message-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.message-cards tr:first-child td {
	padding-top: 12px !important;
}
.message-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.message-cards tr + tr td {
	padding-top: 8px !important;
}
</style>
